"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupWrapper = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
const Icon_1 = require("../../Icon");
require("../index.scss");
const className = 'popup';
const PopupWrapper = (props) => {
    const { onClose, isCloseButtonVisible = true, isOpened, modificators, children } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    if (!isOpened)
        return null;
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__overlay`, onClick: onClose }),
        react_1.default.createElement("div", { className: `${className}__window` },
            react_1.default.createElement("div", { className: `${className}__inner` },
                react_1.default.createElement("div", { className: `${className}__body` },
                    isCloseButtonVisible && (react_1.default.createElement("button", { onClick: onClose, role: 'button', className: `${className}__close`, title: 'schlie\u00DFen' },
                        react_1.default.createElement(Icon_1.Icon, { name: 'x' }))),
                    react_1.default.createElement("div", { className: `${className}__content` }, children))))));
};
exports.PopupWrapper = PopupWrapper;
//# sourceMappingURL=index.js.map